import { render, staticRenderFns } from "./bad.vue?vue&type=template&id=6eb521b5&scoped=true&"
import script from "./bad.vue?vue&type=script&lang=js&"
export * from "./bad.vue?vue&type=script&lang=js&"
import style0 from "./bad.vue?vue&type=style&index=0&id=6eb521b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb521b5",
  null
  
)

export default component.exports